import { useEffect, useState } from 'react';
import DateField from '../components/DateField.jsx';
import { api, withQuery, dateTime } from '../api.js';
import { Pager } from './Products.jsx';
import DocumentPreviewModal from '../components/DocumentPreviewModal.jsx';

const PAGE = 100;

const ACTION_LABEL = {
  create: 'създаване',
  create_confirmed: 'създаване и провеждане',
  confirm: 'провеждане',
  storno: 'сторниране',
  update: 'промяна',
  view: 'преглед',
  login: 'вход',
  logout: 'изход',
  login_failed: 'неуспешен вход',
  export: 'справка',
};

const ENTITY_LABEL = {
  documents: 'документ',
  products: 'стока',
  partners: 'контрагент',
  payments: 'плащане',
  users: 'потребител',
  audit_log: 'одитен дневник',
};

export default function AuditLog() {
  const [filters, setFilters] = useState({ from: '', to: '', action: '', entity: '' });
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState({ items: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [previewId, setPreviewId] = useState(null);

  useEffect(() => {
    setLoading(true);
    api.get(withQuery('/api/reports/audit', { ...filters, limit: PAGE, offset }))
      .then(setData)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [filters, offset]);

  function change(patch) {
    setOffset(0);
    setFilters((f) => ({ ...f, ...patch }));
  }

  return (
    <>
      <div className="page-head">
        <h1>Одитен дневник</h1>
        <div className="spacer" />
        <span className="hint">записите не подлежат на промяна и изтриване</span>
      </div>

      {error && <div className="error">{error}</div>}

      <div className="toolbar">
        <label className="field">
          От дата
          <DateField value={filters.from} onChange={(v) => change({ from: v })} />
        </label>
        <label className="field">
          До дата
          <DateField value={filters.to} onChange={(v) => change({ to: v })} />
        </label>
        <label className="field">
          Действие
          <select value={filters.action} onChange={(e) => change({ action: e.target.value })}>
            <option value="">всички</option>
            {Object.entries(ACTION_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </label>
        <label className="field">
          Обект
          <select value={filters.entity} onChange={(e) => change({ entity: e.target.value })}>
            <option value="">всички</option>
            {Object.entries(ENTITY_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </label>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table className="compact">
            <thead>
              <tr>
                <th>Кога</th><th>Потребител</th><th>Действие</th>
                <th>Обект</th><th>Документ</th><th>УНП</th><th>Адрес</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((r) => (
                <tr key={r.id}>
                  <td>{dateTime(r.at)}</td>
                  <td>{r.username ?? <span className="muted">—</span>}</td>
                  <td>
                    {r.action === 'login_failed'
                      ? <span className="badge danger">{ACTION_LABEL[r.action]}</span>
                      : ACTION_LABEL[r.action] ?? r.action}
                  </td>
                  <td className="muted">{ENTITY_LABEL[r.entity] ?? r.entity}</td>
                  <td className="muted">
                    {r.entity === 'documents' && r.entity_id
                      ? <button className="link" onClick={() => setPreviewId(r.entity_id)}>{r.doc_number ?? '—'}</button>
                      : (r.doc_number ?? '—')}
                  </td>
                  <td className="muted">{r.unp ?? '—'}</td>
                  <td className="muted">{r.ip_address ?? '—'}</td>
                </tr>
              ))}
              {!loading && data.items.length === 0 && (
                <tr><td colSpan={7} className="empty">Няма записи</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="pager">
          <button disabled={offset === 0 || loading} onClick={() => setOffset(Math.max(0, offset - PAGE))}>
            ← назад
          </button>
          <button disabled={data.items.length < PAGE || loading} onClick={() => setOffset(offset + PAGE)}>
            напред →
          </button>
          <span>{loading ? 'зареждане…' : `записи ${offset + 1}–${offset + data.items.length}`}</span>
        </div>
      </div>

      {previewId && (
        <DocumentPreviewModal documentId={previewId} onClose={() => setPreviewId(null)} />
      )}
    </>
  );
}
